import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { ApiService } from 'app/core/http/api.service';
import { environment as env } from '@env/environment';

@Component({
  selector: 'app-timer',
  templateUrl: './timer.component.html',
  styleUrls: ['./timer.component.css'],
})
export class TimerComponent implements OnInit {
  startTimer = false;
  conference: any;

  days: any;
  hours: any;
  mins: any;
  secs: any;

  /* 🔴 Progress values for circular gauges (0 → 1) */
  dayProgress = 0;
  hourProgress = 0;
  minuteProgress = 0;
  secondProgress = 0;

  livenow = false;

  eventStart: any;
  timeNow: any;

  remainderSeconds = 0;

  @Output() liveEvent = new EventEmitter<boolean>();

  constructor(private apiServerice: ApiService) {}

  sendLive() {
    this.liveEvent.emit(this.livenow);
  }

  ngOnInit(): void {
    this.doConference();

    setInterval(() => {
      if (this.startTimer) {
        this.calc_timer();
      }
    }, 1000);
  }

  doConference() {
    this.apiServerice
      .doGet(`conferences/${env.selectedEvent}`)
      .subscribe((res) => {
        this.conference = res;

        this.eventStart = this.conference.timer;
        this.timeNow = this.conference.time_now;

        this.remainderSeconds =
          (new Date(this.eventStart).valueOf() -
            new Date(this.timeNow).valueOf()) /
          1000;

        this.startTimer = true;
      });
  }

  calc_timer() {
    if (this.remainderSeconds - 60 * 5 <= 0) {
      this.livenow = true;
      this.sendLive();

      this.days = '00';
      this.hours = '00';
      this.mins = '00';
      this.secs = '00';

      /* Reset progress */
      this.dayProgress = 0;
      this.hourProgress = 0;
      this.minuteProgress = 0;
      this.secondProgress = 0;

      return;
    }

    this.remainderSeconds -= 1;
    let seconds = this.remainderSeconds;

    let d = Math.floor(seconds / (60 * 60 * 24));
    seconds -= d * 60 * 60 * 24;

    let h = Math.floor(seconds / (60 * 60));
    seconds -= h * 60 * 60;

    let m = Math.floor(seconds / 60);
    seconds -= m * 60;

    let s = Math.floor(seconds);

    /* Format for UI */
    this.days = d >= 10 ? d : '0' + d;
    this.hours = h >= 10 ? h : '0' + h;
    this.mins = m >= 10 ? m : '0' + m;
    this.secs = s >= 10 ? s : '0' + s;

    /* 🔴 Circular progress calculations */
    this.secondProgress = s / 60;
    this.minuteProgress = m / 60;
    this.hourProgress = h / 24;

    /* Days ring: based on remaining total days (cap at 30 for UI sanity) */
    const maxDays = 30;
    this.dayProgress = Math.min(d / maxDays, 1);
  }

  getTimesInSeconds(str: string) {
    let h = Number.parseInt(str.substr(11, 2));
    let m = Number.parseInt(str.substr(14, 2));
    let s = Number.parseInt(str.substr(17, 2));

    let date_str = str.substr(0, 10);
    let date = new Date(date_str);

    let result =
      date.valueOf() + h * 3600000 + m * 60000 + s * 1000;

    return result / 1000;
  }
}